import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Select} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

import {DEFAULT_OPTIONS, PROPERTY} from "@irati/recognition/constants/share"
import ShareRow from "./shared/ShareRow"

class Share extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    showPrivate: PropTypes.bool,
    options: PropTypes.array
  }

  static defaultProps = {
    label: "platform.fields.share.label",
    placeholder: "platform.fields.share.label",
    valueRenderer: ShareRow,
    showPrivate: true,
    id: "share",
    options: null
  }

  handleChange = (value, option) => {
    const {poll, onChange} = this.props
    return onChange(poll, PROPERTY, option)
  }

  getValue = () => {
    const {poll} = this.props
    return get(poll, PROPERTY, null)
  }

  render() {
    const {poll, intl, options, ...props} = this.props

    return (
      <Select
        options={options || DEFAULT_OPTIONS(intl)}
        {...props}
        onChange={this.handleChange}
        isSearchable={false}
        isClearable={false}
        id={id(PROPERTY, this.props)}
        name={id(PROPERTY, this.props)}
        value={this.getValue()}
      />
    )
  }
}
export default injectIntl(Share)
